import { render, staticRenderFns } from "./HeatingEmissionFactors.vue?vue&type=template&id=0c5ecb58&scoped=true"
import script from "./HeatingEmissionFactors.vue?vue&type=script&lang=js"
export * from "./HeatingEmissionFactors.vue?vue&type=script&lang=js"
import style0 from "./HeatingEmissionFactors.vue?vue&type=style&index=0&id=0c5ecb58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5ecb58",
  null
  
)

export default component.exports